module.exports = __webpack_public_path__ + "fonts/4fcc65e861ad8b634c6473cb1867fa29.woff2";